import { acceptHMRUpdate, defineStore } from 'pinia'

export const useGetInTouch = defineStore('getintouch', {
	namespaced: true,

	state: () => ({
		showModal: false,
		isLoading: false,
		isSubmitting: false,
		isSubmitted: false,
		errors: null,
	}),

	getters: {
		getShowModal: (state) => state.showModal,

		getIsLoading: (state) => state.isLoading,
		getIsSubmitting: (state) => state.isSubmitting,
		getIsSubmitted: (state) => state.isSubmitted,

		hasErrors: (state) => state.errors,
	},

	actions: {
		resetStates() {
			this.isLoading = false
			this.isSubmitting = false
			this.isSubmitted = false
			this.errors = null
		},
		resetModal() {
			this.showModal = false
		},
	},
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useGetInTouch, import.meta.hot))
}
